/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CompanyIntegrationSummaryCto } from '../../models/company-integration-summary-cto';

export interface GetSummary$Plain$Params {
  companyGuid: string;
}

export function getSummary$Plain(http: HttpClient, rootUrl: string, params: GetSummary$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<CompanyIntegrationSummaryCto>> {
  const rb = new RequestBuilder(rootUrl, getSummary$Plain.PATH, 'get');
  if (params) {
    rb.path('companyGuid', params.companyGuid, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CompanyIntegrationSummaryCto>;
    })
  );
}

getSummary$Plain.PATH = '/integrations/companies/{companyGuid}/summary';
